import api from "../../api/axios";

export const getAllUsers = async (params) => {
  let response = await api.get("/users", { params });
  return response.data;
};

export const createNewUser = async (payload) => {
  let response = await api.post("/users", payload);
  return response.data;
};

export const updateUser = async (id, payload) => {
  let response = await api.put(`/users/${id}`, payload);
  return response.data;
};
